import { render, staticRenderFns } from "./BaseCell.vue?vue&type=template&id=157e2591&scoped=true&"
import script from "./BaseCell.vue?vue&type=script&lang=js&"
export * from "./BaseCell.vue?vue&type=script&lang=js&"
import style0 from "./BaseCell.vue?vue&type=style&index=0&id=157e2591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e2591",
  null
  
)

export default component.exports